import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import AsyncSelectSearchFieldProps from './dto';

const AsyncSelectSearchField = <T,>({
    fetchData,
    disabled = false,
    getOptionLabel,
    isOptionEqualToValue,
    value,
    setValue,
}: AsyncSelectSearchFieldProps<T>) => {
    const [options, setOptions] = useState<T[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState('');

    const interval = useRef<any>();

    useEffect(() => {
        setLoading(true);

        interval.current = setTimeout(
            () =>
                fetchData(inputValue)
                    .then((options) => setOptions(options))
                    .finally(() => setLoading(false)),
            500,
        );

        return () => {
            clearTimeout(interval.current);
        };
    }, [inputValue, fetchData]);

    return (
        <>
            <Autocomplete
                multiple={false}
                options={options}
                popupIcon={loading ? <CircularProgress size={20} /> : undefined}
                loading={loading}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={isOptionEqualToValue}
                disabled={disabled}
                value={value}
                onChange={(_, newValue) => {
                    setValue(newValue);
                }}
                onInputChange={(_, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                renderInput={(params) => <TextField {...params} label="Filter by Tournament" />}
                filterOptions={(x) => x}
            />
        </>
    );
};

export default AsyncSelectSearchField;
